import { inject, provide } from 'vue';

const KEY = Symbol('in-modal');

export function provideInModal(value: boolean) {
  return provide(KEY, value);
}

export function injectInModal() {
  return inject<boolean>(KEY)!;
}
